import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavBar from "./NavBar";
import MainPage from "./MainPage";
import InsightPage from "./InsightPage";
import HugMySelfPage from "./HugMySelfPage";
import RewriteItPage from "./RewriteItPage";
import ContactPage from "./ContactPage";

function NotFound() {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="p-8 text-center animate-fade-in">
      <img
        src="https://illustrations.popsy.co/gray/error-404.svg"
        alt="404 Illustration"
        className="mx-auto mb-6 w-64"
      />
      <h1 className="text-5xl font-bold text-red-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Oops! Page Not Found</h2>
      <p className="text-md text-gray-600 mb-6">We couldn't find what you were looking for.</p>
      <p className="text-sm text-gray-500 mb-4">Redirecting you to the homepage in 5 seconds...</p>
      <a href="/" className="text-blue-600 hover:underline">Click here if you're not redirected</a>
    </div>
  );
}

function App() {
  return (
    <Router>
      <NavBar />
      <main className="pt-6 animate-page">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/insight" element={<InsightPage />} />
          <Route path="/hugmyself" element={<HugMySelfPage />} />
          <Route path="/rewrite-it" element={<RewriteItPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
